"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

function _default(Component) {
  var ShareButtonDecorator =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(ShareButtonDecorator, _React$Component);

    function ShareButtonDecorator() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2.default)(this, ShareButtonDecorator);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ShareButtonDecorator)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this._defaultButtonRef = {
        current: null
      };
      _this.focus = _this.focus.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(ShareButtonDecorator, [{
      key: "focus",
      value: function focus() {
        var buttonRef = this.props.buttonRef || this._defaultButtonRef;

        if (buttonRef.current && typeof buttonRef.current.focus === 'function') {
          buttonRef.current.focus();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            buttonRef = _this$props.buttonRef,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["buttonRef"]);
        return _react.default.createElement(Component, (0, _extends2.default)({}, rest, {
          buttonRef: buttonRef || this._defaultButtonRef
        }));
      }
    }]);
    return ShareButtonDecorator;
  }(_react.default.Component);

  var componentName = (0, _getComponentName.default)(Component);
  ShareButtonDecorator.displayName = "ShareButton(" + componentName + ")";
  ShareButtonDecorator.propTypes = (0, _extends2.default)({}, Component.propTypes, {
    buttonRef: _refObject.default
  });
  ShareButtonDecorator.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(ShareButtonDecorator, Component);
  return ShareButtonDecorator;
}

module.exports = exports.default;